// ============================================================
//  OVERBOOKED — SITE CONFIG  (edit everything in this one block)
// ============================================================
//  Swap the brand name once here to rename the whole site.
export const BRAND_NAME = "Slammed";

//  Parent company shown in the footer legal line.
export const PARENT_CO = "[Parent Co]";

//  Name that payments are billed/descriptored as (shown at checkout + footer).
export const BILLING_NAME = "Slammed";

//  The recurring monthly price shown across the page.
export const PRICE = "$297";
export const PRICE_MO = "$297/mo";

//  Limited-time tripwire: $27 charged today (first month), then $297/mo after 30 days.
export const START_PRICE = "$27";
export const START_TAGLINE = "$27 today, then $297/mo after 30 days";
export const START_CTA = "Start for $27";
export const LIMITED_LABEL = "Limited-time offer";

// ------------------------------------------------------------
//  CONVERSION ENDPOINTS  (paste your real values below)
// ------------------------------------------------------------
//  1. GoHighLevel inbound webhook — lead JSON is POSTed here.
export const GHL_WEBHOOK_URL = "https://services.leadconnectorhq.com/hooks/QKOKvLrjcc912nZAqa8u/webhook-trigger/b44e1651-942a-47f8-8db2-a6876a9dd3b9";

//  2. Hosted checkout link the browser redirects to AFTER the lead is captured.
//     Provider-agnostic — use ANY shareable checkout URL:
//       • Whop   e.g. https://whop.com/checkout/plan_XXXXXXXX/
//       • Square e.g. https://square.link/u/XXXXXXXX
//       • Stripe Payment Link e.g. https://buy.stripe.com/XXXXXXXX
export const CHECKOUT_URL = "https://whop.com/checkout/233Xo6lgMir3NiT6ut-HolZ-nOJC-HLtE-HHYTHAEhkF2L/";

//  Whop plan id for the on-site EMBEDDED checkout (/checkout page).
//  When set, the lead form sends buyers to the on-site embed instead of the
//  hosted CHECKOUT_URL redirect above.
export const WHOP_PLAN_ID = "plan_UEabQk6nlRb5f";

//  (legacy alias — CHECKOUT_URL takes priority when both are set)
export const SQUARE_CHECKOUT_URL = "PASTE_YOUR_SQUARE_CHECKOUT_URL";

//  3. Meta Pixel ID — loaded in <head>, fires InitiateCheckout + Lead.
export const META_PIXEL_ID = "1480255950602965";

// ------------------------------------------------------------
//  HERO VIDEO (VSL) — optional.
//  Paste a direct video file URL (.mp4 / .webm) to enable a click-to-play
//  demo video. Leave as-is to keep the styled placeholder.
export const VSL_VIDEO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_lead-booking-flow/artifacts/k6ed5wlu_Get%20More%20Leads%20and%20Bookings%20with%20AI.mp4";
// Lightweight muted highlight clip (the "We run your ads / leads / appointments"
// segment) that loops silently before the visitor clicks to watch with sound.
export const VSL_PREVIEW_URL = "/vsl-preview.mp4";
export const VSL_POSTER_URL = "PASTE_YOUR_VSL_POSTER_IMAGE_URL";

// Zuops (white-labeled) account-creation link, embedded on the kickoff page
// after the call is booked.
export const ZUOPS_ACCOUNT_URL = "https://app.tryslammed.io/join/slammed-account-creation";

// ------------------------------------------------------------
//  Helper: is a config value a real value (not the placeholder)?
export const isSet = (v) =>
  typeof v === "string" && v.length > 0 && !v.startsWith("PASTE_");
